export function showIntercomMessage(message: string) {
  // setTimeout to make sure Intercom is initialized even if component is unmounted
  setTimeout(() => {
    window.Intercom("showNewMessage", message);
  }, 0);
}
